(function (angular) {
    'use strict';

    angular.module('ui.order.newOrder.createService', [])

        .service('newOrderCreateService', function ($q, fileService, newOrderDataService, newOrderProgressService,
                                                    addressesRepository, customersRepository, ordersRepository) {

            angular.extend(this, {
                init: init,
                destroy: destroy,
                createOrder: createOrderChain
            });

            var _this = this;

            var _orderVm = {};
            var _orderItemsVms = [];
            var _deliveryAddress = null;
            var _outerProgressCallback = undefined;
            var _newOrderId = 0;

            return _this;

            function createOrderChain(orderVm, deliveryAddress, orderItemsVms, progressCallback) {

                _orderVm = orderVm;
                _orderItemsVms = orderItemsVms;
                _deliveryAddress = deliveryAddress;
                _outerProgressCallback = progressCallback;

                _newOrderId = 0;

                return orderAddress()
                    .then(createOrder)
                    .then(getOrderItems)
                    .then(uploadAllFiles)
                    .then(returnOrderId);
            }

            function orderAddress() {
                if (_deliveryAddress.id) {
                    return $q.when(_deliveryAddress);
                } else {
                    return addressesRepository.createAddress(_deliveryAddress)
                        .then(setAsCustomerDeliveryAddress);
                }
            }

            function setAsCustomerDeliveryAddress(addressModel) {
                return customersRepository
                    .setCustomerDeliveryAddress(_orderVm.customerId, addressModel.$model.id)
                    .then(function () {
                        return addressModel.$model;
                    });
            }

            function createOrder(address) {
                return ordersRepository.createOrder({
                    "order": _orderVm,
                    "items": _orderItemsVms,
                    "address": address,
                    "actionToExecute": newOrderDataService.orderCreationAction
                }).then(function (newOrderId) {
                    _newOrderId = newOrderId;
                    return _newOrderId;
                });
            }

            function getOrderItems(orderId) {
                return ordersRepository.getOrderItemsForOrder(orderId);
            }

            function uploadAllFiles(orderItems) {
                setFilesSize();

                return $q.all(_.map(_orderItemsVms, function (orderItemVm, index) {
                    return uploadFiles(orderItemVm.files, orderItems[index].$model.id);
                }));
            }

            function setFilesSize() {
                var filesSize = 0;
                angular.forEach(_orderItemsVms, function (item) {
                    angular.forEach(item.files, function (file) {
                        filesSize += file.size;
                    });
                });
                newOrderProgressService.init(filesSize);
            }

            function uploadFiles(files, orderItemId) {
                var chunkSize = 1000000;
                return fileService.uploadFiles(files, chunkSize, 1, 1, undefined, progressCallback, orderItemId, true);
            }

            function progressCallback(file, progress, sessionId) {
                newOrderProgressService.setFileProgress(file, progress, sessionId);
                _outerProgressCallback();
            }

            function returnOrderId() {
                return _newOrderId;
            }

            function init() {
                return $q.all([]);
            }

            function destroy() {
            }
        });
})(window.angular);
